const PB_URL = process.env.REACT_APP_PB_URL || '';

export async function getLatestVersion() {
  try {
    const response = await fetch(
      `${PB_URL}/api/collections/Version_Logs/records?filter=env='AUP'&sort=-created&perPage=1`,
      {
        headers: {
          'Content-Type': 'application/json',
        },
      }
    );
    
    if (!response.ok) throw new Error('Failed to fetch version');
    
    const data = await response.json();
    return data.items?.[0]?.version || '0.1.1'; // Fallback version
  } catch (error) {
    console.error('Error fetching version:', error);
    return '0.1.1'; // Fallback version
  }
} 